module.exports = __webpack_public_path__ + "static/media/foto2.30cd252e.jpg";